import React, { useContext } from 'react';
import { PayPalMessages } from '@paypal/react-paypal-js';
import styled from 'styled-components';
import { Context } from '@components/Context';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import { calculateTotalPrice } from '@utils/cart';

const PayPalMessage: React.FC = () => {
  const { state } = useContext(Context);
  const { currency } = state;
  const { selectedCartItems } = useShoppingContext();
  const totalPrice = calculateTotalPrice(selectedCartItems);

  return (
    <Container>
      <PayPalMessages amount={totalPrice?.toFixed(2)} currency={currency.letterCode} placement="product" style={{ text: { align: 'center' } }} />
    </Container>
  );
};

export default PayPalMessage;

const Container = styled.div`
  margin-top: 24px;
  width: 100%;
`;
